import {
  Page,
  commonValues
} from './common-modules.js';

export {
  contactHistoryTxtCut,
  comparisonItem
};

var contactHistoryTxtCut = function(){
  var lines = Page.isSp() ? 2 : 1;
  $('.js-contact-history-txt').trunk8({
      lines: lines
  });
}

var comparisonItem = function(){  

  function alignSectionHeight(selector){
    var height = 0;
    $(selector).css({'height': 'auto'});
    $(selector).each(function(){
      if(height < $(this).outerHeight()){
        height = $(this).outerHeight();
      }
    });
    $(selector).css({'height': height});
    height = 0;
  }

  return {
    hideItem: function(){
      //要素非表示（再表示はしないのでHTML削除）
      $('.js-comparison-item-hide').on('click', function(){
        $(this).closest('.item-box').remove();
        comparisonItem().matchHeight();
      });
      return this;
    },
    itemImgSlide: function(){
      //スライダー
      $('.js-comparison-item-slide').each(function(index){
        var $this = $(this);
        $this.addClass('item-slide-' + index);
        $this.find('.js-item-prev').addClass('btn-prev-' + index);
        $this.find('.js-item-next').addClass('btn-next-' + index);


        var slideLength = $this.find('.js-item-slide').length;
        var hasOneSlide = slideLength === 1;

        var instance = new Swiper('.item-slide-' + index, {
          init: false,
          effect: 'slide',
          speed: 600, 
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: '.btn-next-' + index,
            prevEl: '.btn-prev-' + index
          }
        });
        instance.on('init', function(){
          if(hasOneSlide){
            instance.destroy();
            $('.btn-next-' + index + ', .btn-prev-' + index).hide();
          }
        });
        instance.init();
      });
      return this;
    },
    matchHeight: function(){
      alignSectionHeight('.js-heading-ah');
      alignSectionHeight('.js-price-ah');
      alignSectionHeight('.js-pos-size-ah');
      alignSectionHeight('.js-material-ah');
      alignSectionHeight('.js-slide-ah');
      return this;
    }
  }
}